import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "apps-page" }
const _hoisted_2 = { class: "apps-page__top" }
const _hoisted_3 = { class: "apps-page__main" }
const _hoisted_4 = { class: "apps-page__content" }

import { ref, computed, onMounted } from "vue";
import { Plus } from "@element-plus/icons-vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import { EmptyData } from "@/shared/ui/components/EmptyData";
import { IApplication } from "@/shared/types/applications";
import CreateAppModal from "./CreateAppModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppsPage',
  setup(__props) {

const store = useStore();

const modalVisible = ref(false);
const pageLoading = ref(false);
const submitLoading = ref(false);

const list = computed<IApplication[]>(() => store.state.applications.list);

onMounted(async () => {
  pageLoading.value = true;
  await store.dispatch("applications/getApplications");
  pageLoading.value = false;
});

const handleCreate = async (payload: { title: string; bundle: string }) => {
  submitLoading.value = true;
  try {
    const response = await store.dispatch(
      "applications/createApplication",
      payload
    );
    if (response) {
      ElMessage({ message: "App created successfully", type: "success" });
      modalVisible.value = false;
      await store.dispatch("applications/getApplications");
    }
  } finally {
    submitLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "apps-page__title" }, "Apps", -1)),
      _createVNode(_component_el_button, {
        type: "success",
        icon: _unref(Plus),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (modalVisible.value = true))
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Create App ", -1)
        ]))]),
        _: 1
      }, 8, ["icon"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_table, {
          data: list.value,
          height: "100%",
          style: {"width":"100%","border-radius":"4px"}
        }, {
          empty: _withCtx(() => [
            _createVNode(_unref(EmptyData), { class: "apps-page__table-empty" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "#",
              width: "70"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.$index + 1), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "title",
              label: "Title"
            }),
            _createVNode(_component_el_table_column, {
              prop: "bundle",
              label: "Bundle"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ]),
    _createVNode(CreateAppModal, {
      modelValue: modalVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modalVisible).value = $event)),
      loading: submitLoading.value,
      onSubmit: handleCreate
    }, null, 8, ["modelValue", "loading"])
  ])), [
    [_directive_loading, pageLoading.value]
  ])
}
}

})